import { api } from '../api.ts';

/**
 * Ein Weg zur Bauakte, neben der Karte.
 *
 * ORIGINALTEXT MARVIN (08.09.2026)
 *   „Bauakte über einen Knopf aus «Lageplan vorbereiten» und «Tiefbauaufwand
 *    planen» erreichbar (als volle Seite)"
 *
 * WER ZEICHNET, HAT DIE BAUAKTE DANEBEN LIEGEN. Sie trägt den Leitungsweg der
 * Telekom, den Rohrverband und den NVt-Standort - also genau das, wonach auf
 * der Karte gezeichnet wird. Erreichbar war sie von hier aus nur über zwei
 * Bildschirmwechsel (Fenster zu, Reiter „Dateien", Ordner durchsehen), und
 * danach ist die Karte weg, auf die man gerade gesehen hat.
 *
 * ES IST EIN LINK UND KEIN FENSTER, und das ist Marvins „als volle Seite":
 * eine PDF in einem Kasten von 600 Bildpunkten ist kein Plan, sondern ein
 * Briefmarkenbild. Der Browser bringt einen Betrachter mit, der die ganze
 * Seite hat, und das Fenster daneben bleibt offen - wer zurückwechselt, steht
 * wieder auf seiner Zeichnung.
 *
 * DIE ADRESSE TRÄGT DEN DATEINAMEN. Wer die Akte im Betrachter speichert,
 * bekommt sonst die Kennung des Dateibezugs vorgeschlagen; dieselbe Regel wie
 * überall seit dem 27.08.2026.
 *
 * UND OHNE BAUAKTE STEHT HIER NICHTS. Ein Knopf, der ins Leere führt, ist
 * schlimmer als keiner: er sieht aus wie ein Weg. Dass sie fehlt, sagt der
 * Block „Technik" in der Akte - dort steht auch, was daraus gelesen wurde.
 */
export default function BauakteWeg(
  { bauakte }: { bauakte?: { id: string; dateiname: string } | null }
) {
  if (!bauakte) return null;
  return (
    <a className="kartenweg" href={api.dateiAdresse(bauakte.id, bauakte.dateiname)}
       target="_blank" rel="noreferrer" title={bauakte.dateiname}>
      Bauakte öffnen
    </a>
  );
}
